export class AddCompanyInfoModel {
  public companyName: string;
  public address: string;
  public email: string;
  public phone: string;
  public countryId: number;
  public languageId: number;
  public businessTypesCompanies: Array<number> = new Array<number>();
}
